import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const UnivapayResultMob = () => {
  return <CommonResult />;
};

export default UnivapayResultMob;
